import { useEffect } from 'react';
import queryString from 'qs';
import { useHistory } from 'hooks/generic/useHistory';
import { useIsLoggedIn } from 'hooks/user/useIsLoggedIn';
import { useAppSelector } from 'appRedux/hooks';
import { getPath } from 'utils';
import {
  AccountQueryKey,
  EAccountRouteKeys
} from 'constants/account/account-route-keys';
import { IS_KIOSK_GENERIC } from 'constants/app/configs';
import {
  ELsKeyAuthReachedFromOptions,
  ELsKeys
} from 'constants/app/storage-keys';
import { AccountType } from 'interfaces';

export const useAttachExternalFunctions = () => {
  const { push } = useHistory();
  const { isLoggedIn, isLoginPending } = useIsLoggedIn();
  const { data: accountCreatorData } = useAppSelector(
    ({ accountCreator }) => accountCreator
  );
  const canCreateNft = [AccountType.Creator, AccountType.Company].includes(
    accountCreatorData?.account_type
  );

  useEffect(() => {
    window.openSigninPopup = () => {
      push(EAccountRouteKeys.ACCOUNT_AUTH);
    };

    window.openAccountMyNfts = () => {
      if (IS_KIOSK_GENERIC) {
        push(EAccountRouteKeys.ACCOUNT_PROFILE_MY_NFTS_OWNED);
        return;
      }

      push(EAccountRouteKeys.ACCOUNT_PROFILE_MY_NFTS);
    };

    window.openAccountCreateNft = (skipStorage?: boolean) => {
      if (IS_KIOSK_GENERIC) {
        return;
      }
      if (!skipStorage && !isLoggedIn && !isLoginPending) {
        localStorage.setItem(
          ELsKeys.AUTH_REACHED_FROM,
          ELsKeyAuthReachedFromOptions.CREATE_NFT
        );
      }
      push({
        pathname: getPath(EAccountRouteKeys.ACCOUNT_PROFILE_MY_NFTS),
        search: queryString.stringify(
          {
            [AccountQueryKey.modal.value]: canCreateNft
              ? AccountQueryKey.modal.option.CHOOSE_CREATE_NFT
              : AccountQueryKey.modal.option.BECOME_CREATOR
          },
          { addQueryPrefix: true }
        )
      });
    };

    window.loggedInCheck = () => {
      if (isLoggedIn) {
        push(EAccountRouteKeys.ACCOUNT_PROFILE_MY_NFTS_OWNED);
        return;
      }

      push(EAccountRouteKeys.ACCOUNT_AUTH);
    };

    return () => {
      window.openSigninPopup = () => {};
      window.openAccountMyNfts = () => {};
      window.openAccountCreateNft = () => {};
      window.loggedInCheck = () => {};
    };
  }, [isLoggedIn, isLoginPending]);
};
